import React from "react"
import {Address} from "../../../resources/common"
import Icon from "../../../components/Icon/Icon"
import {KeyValueCard, KeyValueCardContainer} from "../../../components/KeyValueCard/KeyValueCard"

interface Props {
	address: Address
	openChangeAddressModal: () => void
}

export default function CheckMailingAddress({address, openChangeAddressModal}: Props) {
	return (
		<div className={"check-mailing-address"}>
			<KeyValueCard
				title={"Check mailing address"}
				className={"check-mailing-address"}
				additionalHeaderContent={
					<div className={"change-button"}>
						<span className="change-link mr-0">
							<Icon icon="pencil-1--interface-essential" size={16} className={"pencil-icon"} />
							<a
								href="#"
								onClick={(e) => {
									e.preventDefault()
									openChangeAddressModal()
								}}
							>
								<span>Change</span>
							</a>
						</span>
					</div>
				}
			>
				<KeyValueCardContainer>
					<article className="mailing-address is-full-width">
						<div className="mailing-content">
							<div className="mailing-address-message-body-icon">
								<Icon icon={"email-envelope-1--emails"} size={16} className="mailing-icon has-semantic-color" />
							</div>
							<div className="mailing-texts">
								<div className="mailing-message-body-container">{address.street}</div>
								<div className="mailing-message-body-container">
									{`${address.city}, ${address.state} ${address.postalCode}, United States Of America`}
								</div>
							</div>
						</div>
					</article>
				</KeyValueCardContainer>
			</KeyValueCard>
		</div>
	)
}
